import { appendScript } from './generic-utilities.es6';

export function addScript() {
    appendScript('//mmtro.com/tro.js');
}
